import "../styles/ContactForm.css";
import { useState } from "react";

export default function ContactForm() {
  const [emailInput, setEmailInput] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  return (
    <section className="contact-form">
      <h2 className="contact-form__title">GET IN TOUCH</h2>
      <form
        name="contact-form"
        method="POST"
        className="contact-form__form"
        onSubmit={(event) => {
          if (!regex.test(emailInput)) {
            event.preventDefault();
            setEmailErr("Please enter a valid email address");
          } else {
            setEmailErr("");
          }
        }}
      >
        <input type="hidden" name="form-name" value="contact-form" />
        <input
          name="name"
          type="text"
          className="contact-form__input"
          placeholder="Name"
          required
        />
        <p className="contact-form__err"></p>
        <input
          name="email"
          type="text"
          className="contact-form__input"
          placeholder="Email"
          value={emailInput}
          onChange={(event) => setEmailInput(event.target.value)}
          required
        />
        <p className="contact-form__err">{emailErr}</p>
        <textarea
          name="text"
          className="contact-form__input"
          placeholder="Comment"
          required
        ></textarea>
        <p className="contact-form__err"></p>
        <input type="submit" value="SUBMIT" />
      </form>
    </section>
  );
}
